import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {getFeatureFlags} from '../../api'
import type {ConfigurationName, FeatureFlag} from '../../types'

export const useFeatureFlagsQuery = ({
  configurationName,
  params
}: {
  configurationName: ConfigurationName
  params?: Record<string, string | number | boolean | string[] | undefined>
}) => {
  return useQuery<FeatureFlag[]>({
    queryKey: ['feature-flags', configurationName, params],
    queryFn: ({signal}) =>
      getFeatureFlags(ApiClient.axiosInstance, configurationName)({params}, signal)
  })
}
